export default "__VITE_ASSET__D9ABe2fs__"